class AngledLine {

	constructor(el, params) {

		// param vars

		this.$el = $(el);
		this.params = params;

		//

		this._width = isNaN(parseFloat(this.$el.attr('data-al-width'))) ? 200 : parseFloat(this.$el.attr('data-al-width'));
		this._height = isNaN(parseFloat(this.$el.attr('data-al-height'))) ? 11 : parseFloat(this.$el.attr('data-al-height'));
		this._stroke = isNaN(parseFloat(this.$el.attr('data-al-stroke'))) ? 3 : parseFloat(this.$el.attr('data-al-stroke'));
		this._vertInset = isNaN(parseFloat(this.$el.attr('data-al-vert-inset'))) ? 2 : parseFloat(this.$el.attr('data-al-vert-inset'));
		this._horizInset = isNaN(parseFloat(this.$el.attr('data-al-horiz-inset'))) ? -2 : parseFloat(this.$el.attr('data-al-horiz-inset'));
		this._isResponsive = typeof(this.$el.data('responsive')) !== 'undefined' && this.$el.data('responsive') !== false;
		this._isSmall = typeof(this.$el.data('small')) !== 'undefined' && this.$el.data('small') !== false;

		//

		this.redraw();

		//

		$(() => {
			this._onDomReady();
		});
	}

	// private methods

	_onDomReady(){
		this._addListeners();
		this._onResize();
	}

	_addListeners(){

		this.$el.on('redraw', this._onRedraw.bind(this));

		window.vent.on('domUpdate', this._onDomUpdate, this);
		window.vent.on('windowResize', this._onResize, this);
	}

	_removeListeners(){
		window.vent.off('domUpdate', this._onDomUpdate, this);
		window.vent.off('windowResize', this._onResize, this);
	}

	_onRedraw(){
		this.redraw();
	}

	_onDomUpdate(e, obj){
		if(obj && obj.$scanContainer[0].contains(this.$el[0])){
			this.redraw();
		}
	}

	_onResize(){

		if(this._isResponsive){
			this._width = this.$el.outerWidth();
			this._height = this.$el.outerHeight();
			this.redraw();
		}
	}

	// public methods

	redraw(){

		// random rect

		let $outlines = this.$el.find('svg');

		if(this.$el.is('svg')){ $outlines = this.$el; }

		$outlines.each((index, value) => {

			let $value = $(value);
			let points = [];
			let pointsShape = {};
			let pointsString = '';
			let coordsIndex = 0;

			// create shape

			for(let i=0; i<4; i++){

				let shiftAmount = this._stroke/4;
				let shiftX = Math.random() < 0.5 ? -shiftAmount : shiftAmount;
				let shiftY = Math.random() < 0.5 ? -shiftAmount : shiftAmount;
				let coords;

				switch(i){

					case 0:
					coords = {
						x: this._horizInset + shiftX,
						y: this._height - this._vertInset + shiftY
					};
					break;

					case 1:
					coords = {
						x: points[0].x + this._stroke/4*3 + shiftX,
						y: points[0].y + this._stroke/4*3 + shiftY
					};
					break;

					case 2:
					coords = {
						x: this._width - this._horizInset + shiftX,
						y: this._vertInset + shiftY
					};
					break;

					case 3:
					coords = {
						x: points[2].x + this._stroke/4*3 + shiftX,
						y: points[2].y + this._stroke/4*3 + shiftY
					};
					break;
				}

				points.push(coords);

				if(i > 0){ pointsString += ' '; }
				pointsString += coords.x + ',' + coords.y;

				coordsIndex++;
			}

			// fix viewbox

			$value.removeAttr('viewBox');
			$value[0].setAttribute('viewBox', '0 0 ' + this._width + ' ' + this._height);

			// fix shape

			$value.find('polygon').attr('points', pointsString);
		});
	}

	// getters / setters

	get width(){ return this._width; }
	set width(value){
		this.width = value;
		this.redraw();
	}

	get height(){ return this._height; }
	set height(value){
		this.height = value;
		this.redraw();
	}
}

module.exports = AngledLine;
